const TaskerLocation = (state = {} , action) => {
    switch(action.type) {
        case 'TRACKER' :
            return state = action.payload;
        default : 
            return state = {};
    }
}
export default TaskerLocation;